module.exports = {
  apiUrl: "https://notes-notable.herokuapp.com/api/",
  notesPreviewLength: 75
};
